import { Component, Input } from '@angular/core';
import { GTMService } from '../../services/gtm.service';
import { ICashbackPartner, ICashbackRate } from '../../interfaces/cashback';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'cashback-partners',
  templateUrl: './cashback-partners.component.html'
})
export class CashbackPartnersComponent {

  // Busca feita pelo search-container (filtrada pelo termo da busca)
  @Input() partners: ICashbackPartner[] = [];

  constructor(private gtm: GTMService) {}

  // Mesma regra do formatCashbackRate (variant 'card') do portal
  formatRate(rate: ICashbackRate): string | null {
    if (!rate || rate.type === 'none' || rate.value == null) {
      return null;
    }

    const value = rate.type === 'fixed'
      ? rate.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : `${rate.value.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`;

    return `Até ${value}`;
  }

  getInitial(partner: ICashbackPartner): string {
    return (partner.name || '').trim().charAt(0).toUpperCase();
  }

  openPartner(partner: ICashbackPartner) {
    this.gtm.interaction('allya', 'cashback:click', partner.slug);
    this.goToPortal(`/cashback/${partner.slug}`);
  }

  openAll() {
    this.gtm.interaction('allya', 'cashback:click', 'ver-tudo');
    this.goToPortal('/cashback');
  }

  private goToPortal(path: string) {
    window.location.href = `${environment.PORTAL_URL}${path}`;
  }
}
